module.exports = __webpack_public_path__ + "static/img/13.e59e47c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/13.png
// module id = 9fTQ
// module chunks = 0